import React, { useEffect, useState } from "react";
import { Col, Form, Row, Spinner, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import Select from 'react-select';
import { IoMdClose } from "react-icons/io";
import { authHeader } from "../../../services/auth-header";
import { BASE_URL } from "../../../services/Api";

const IRMDCreate = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [rows, setRows] = useState([]);
    const [productOptions, setProductOptions] = useState([]);
    const unitOptions = [
        { value: "", label: "Select UOM" },
        { value: "bot", label: "Bot" },
        { value: "ctn", label: "Ctn" },
        { value: "days", label: "Days" },
        { value: "ft", label: "Ft" },
        { value: "hrs", label: "Hrs" },
        { value: "kg", label: "Kg" },
        { value: "ltr", label: "Ltr" },
        { value: "mtr", label: "Mtr" },
        { value: "nos", label: "Nos" },
        { value: "pil", label: "Pil" },
        { value: "pkt", label: "Pkt" },
        { value: "set", label: "Set" },
        { value: "pcs", label: "Pcs" }
    ];


    // poitems
    const [supplier, setSupplier] = useState(null);
    const [supplierOptions, setSupplierOptions] = useState([]);
    const [supplierDetails, setSupplierDetails] = useState({
        contactperson: '',
        address: '',
        contactno: '',
        email: '',
    });
    const [supplierAddresses, setSupplierAddresses] = useState([]);
    const [supplierMultipleAddress, setSupplierMultipleAddress] = useState(null);
    const [branch, setBranch] = useState(null);
    const [branchOptions, setBranchOptions] = useState([]);
    const [warehouse, setWarehouse] = useState(null);
    const [warehouseOptions, setWarehouseOptions] = useState([]);
    const [podate, setpodate] = useState("");
    const [shipto, setshipto] = useState("");
    const [deliverynotedate, setdeliverynotedate] = useState('');
    const [mrnno, setmrnno] = useState("");
    const [mrndate, setmrndate] = useState('');
    const [deliverynoteno, setdeliverynoteno] = useState('');
    const [pono, setpono] = useState('');
    const [status, setstatus] = useState('');
    const [inspectionreportno, setinspectionreportno] = useState('');
    const [inspectionreportdate, setinspectionreportdate] = useState('');




    useEffect(() => {
        getBranchData();
        getWarehouseData();
        getSupplierData();
        getPumpProductData();
    }, []);

    const getPumpProductData = async () => {
        try {
            const response = await axios.get(BASE_URL + 'product/getAllDomesticMfgProduct', {
                headers: authHeader(),
            });
            setProductOptions(response.data.map(product => ({
                value: product.id,
                label: product.description,
                uom: product.unitofmeasurement || unitOptions[0].value,
            })));
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch Product. Please try again.',
            });
        }
    };

    const handleProductChange = (selectedOption) => {
        setSelectedProduct(selectedOption);
        const selectedProductData = productOptions.find(product => product.value === selectedOption.value);
        if (selectedProductData) {
            const newRow = {
                product: { id: selectedOption.value, name: selectedOption.label },
                uom: selectedProductData.uom || unitOptions[0].value,
            };
            setRows([...rows, newRow]);
        }
    };

    const handleRowChange = (index, key, value) => {
        const updatedRows = [...rows];
        updatedRows[index][key] = value;
        setRows(updatedRows);
    };

    const removeRow = (index) => {
        const updatedRows = [...rows];
        updatedRows.splice(index, 1);
        setRows(updatedRows);
    };
    // PO item


    const getSupplierData = async () => {
        try {
            const response = await axios.get(`${BASE_URL}supplier/findAllSupplier`, {
                headers: authHeader(),
            });
            setSupplierOptions(response.data.map(supplier => ({
                value: supplier.id,
                label: supplier.companyname
            })));
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch supplier. Please try again.',
            });
        }
    };

    const getSupplierDetails = async (id) => {
        try {
            const response = await axios.get(`${BASE_URL}supplier/findById/${id}`, {
                headers: authHeader(),
            });
            setSupplierDetails({
                contactperson: response.data.contactperson,
                contactno: response.data.contactno,
                email: response.data.email,
            });
            // Fetch addresses for the selected supplier
            getSupplierAddresses(id);
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch supplier details. Please try again.',
            });
        }
    };

    const getSupplierAddresses = async (id) => {
        try {
            const response = await axios.get(`${BASE_URL}supplierMultipleAddress/getAddress/${id}`, {
                headers: authHeader(),
            });
            console.log('address', response.data);
            setSupplierAddresses(response.data.map(address => ({
                value: address.id,
                label: address.supplieraddress
            })));
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch supplier addresses. Please try again.',
            });
        }
    };


    const handleSupplierAddressesChange = (selectedOption) => {
        console.log('select add', selectedOption);
        // Update the supplier address state with the selected option
        if (selectedOption) {
            setSupplierMultipleAddress([selectedOption]);
        } else {
            setSupplierAddresses([]); // Clear if nothing is selected
        }
    };

    const handleSupplierChange = (selectedOption) => {
        setSupplier(selectedOption);
        setSupplierMultipleAddress('');
        if (selectedOption) {
            getSupplierDetails(selectedOption.value);
        } else {
            setSupplierDetails({
                contactperson: "",
                address: '',
                contactno: '',
                email: ""
            });
            setSupplierAddresses([]);
        }
    };



    const getWarehouseData = async () => {
        try {
            const response = await axios.get(BASE_URL + 'warehouse/findAllWarehouse', {
                headers: authHeader(),
            });
            setWarehouseOptions(response.data.map(warehouse => ({ value: warehouse.id, label: warehouse.warehousename })));
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch Warehouse. Please try again.',
            });
        }
    };

    const handleWarehouseChange = async (selectedOption) => {
        setWarehouse(selectedOption);
        if (selectedOption) {
            try {
                const response = await axios.get(`${BASE_URL}warehouse/findById/${selectedOption.value}`, {
                    headers: authHeader(),
                });
                const data = response.data;
                setshipto(data.address); // Assuming the warehouse data has an 'address' field
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to fetch warehouse details. Please try again.',
                });
            }
        } else {
            setshipto("");
        }
    };


    const getBranchData = async () => {
        try {
            const response = await axios.get(BASE_URL + 'branch/findAllBranch', {
                headers: authHeader(),
            });
            setBranchOptions(response.data.map(branch => ({ value: branch.id, label: branch.branchname })));
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch branch. Please try again.',
            });
        }
    };

    const handleBranchChange = (selectedOption) => {
        setBranch(selectedOption);
    };


    const handleSubmit = async () => {
        const inspectionReportItems = rows.map(row => ({
            product: { id: row.product.id },
            product: { id: row.product.id },
            moc: row.moc || '',
            type: row.type || '',
            size: row.size || '',
            rating: row.rating || '',
            classes: row.classes || '',
            schedule: row.schedule || '',
            certification: row.certification || '',

            mtrno: row.mtrno || '',
            detailmaterialdescription: row.detailmaterialdescription || '',
            visualinspection: row.visualinspection || '',
            dimensionalinspection: row.dimensionalinspection || '',
            markingonmaterial: row.markingonmaterial || '',
            verificationofmtr: row.verificationofmtr || '',
            remarksifany: row.remarksifany || '',
            measuringinstruments: row.measuringinstruments || '',
            inspectionmark: row.inspectionmark || '',
            quantityreceived: row.quantityreceived || '',
            quantityaccepted: row.quantityaccepted || '',
            calibrationvalidupto: row.calibrationvalidupto || '',
            make: row.make || '',
            heatnobatchno: row.heatnobatchno || '',
            platenosrno: row.platenosrno || '',
        }));
        const mrnData = {
            inspectionReportItems,
            inspectionreporttype: 'Manufacturing',
            inspectionreportcategory: 'Domestic',
            supplier: { id: supplier.value },
            contactno: supplierDetails.contactno,
            contactperson: supplierDetails.contactperson,
            email: supplierDetails.email,
            supplierMultipleAddress: { id: supplierMultipleAddress[0]?.value },
            branch: branch ? { id: branch.value } : null,
            warehouse: warehouse ? { id: warehouse.value } : null,
            podate,
            shipto,
            deliverynotedate,
            deliverynoteno,
            mrnno,
            mrndate,
            pono,
            status,
            inspectionreportno,
            inspectionreportdate,
        };
        console.log('inspection data', mrnData);
        try {
            const response = await axios.post(BASE_URL + "inspectionReport/save", mrnData, {
                headers: authHeader()
            });
            console.log('inspection api', response.data);
            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Inspection Report added successfully!',
            });
            navigate("/irindex/1");
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response.data || 'Failed to add inspection report. Please try again.',
            });
        }
    };

    return (
        <div className="container">
            <br></br>
            <Form>
                <Row>
                    <Col md="6">
                        <Form.Group >
                            <Form.Label>Inspection Report No.</Form.Label>
                            <Form.Control
                                type="text"
                                value={inspectionreportno}
                                onChange={(e) => setinspectionreportno(e.target.value)}
                                disabled
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group >
                            <Form.Label>Inspection Report Date</Form.Label>
                            <Form.Control
                                type="date"
                                value={inspectionreportdate}
                                onChange={(e) => setinspectionreportdate(e.target.value)}
                            />
                        </Form.Group>
                    </Col>

                    <Col md="6">
                        <Form.Group >
                            <Form.Label>MRN No.</Form.Label>
                            <Form.Control
                                type="text"
                                value={mrnno}
                                onChange={(e) => setmrnno(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group >
                            <Form.Label>MRN Date</Form.Label>
                            <Form.Control
                                type="date"
                                value={mrndate}
                                onChange={(e) => setmrndate(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group >
                            <Form.Label >Delivery Note No.</Form.Label>
                            <Form.Control
                                type="text"
                                value={deliverynoteno}
                                onChange={(e) => setdeliverynoteno(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group >
                            <Form.Label htmlFor="lot-no"> Delivery Note Date</Form.Label>
                            <Form.Control
                                type="date"
                                value={deliverynotedate}
                                onChange={(e) => setdeliverynotedate(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group >
                            <Form.Label>Purchase Order No.</Form.Label>
                            <Form.Control
                                type="text"
                                value={pono}
                                onChange={(e) => setpono(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group >
                            <Form.Label>Purchase Order Date</Form.Label>
                            <Form.Control
                                type="date"
                                value={podate}
                                onChange={(e) => setpodate(e.target.value)}
                            />
                        </Form.Group>
                    </Col>

                    <Col md="6">
                        <Form.Group >
                            <Form.Label>Branch</Form.Label>
                            <Select
                                value={branch}
                                onChange={handleBranchChange}
                                options={branchOptions}
                                placeholder="Select branch"
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group >
                            <Form.Label>Warehouse</Form.Label>
                            <Select
                                value={warehouse}
                                onChange={handleWarehouseChange}
                                options={warehouseOptions}
                                placeholder="Select Warehouse"
                            />
                        </Form.Group>
                    </Col>
                    <Col md="12">
                        <Form.Group >
                            <Form.Label>Ship To</Form.Label>
                            <Form.Control as="textarea" rows={2}
                                value={shipto}
                                onChange={(e) => setshipto(e.target.value)}
                                placeholder="Enter Shipping  Address "
                            />
                        </Form.Group>
                    </Col>
                    {/* Supplier */}
                    <Col md="6">
                        <Form.Group controlId="supplier">
                            <Form.Label>Supplier:</Form.Label>
                            <Select
                                value={supplier}
                                onChange={handleSupplierChange}
                                options={supplierOptions}
                                placeholder="Select supplier"
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group controlId="contactperson">
                            <Form.Label>Contact Person</Form.Label>
                            <Form.Control
                                type="text"
                                value={supplierDetails.contactperson}
                                disabled
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group controlId="contactno">
                            <Form.Label>Supplier Phone Number:</Form.Label>
                            <Form.Control
                                type="text"
                                value={supplierDetails.contactno}
                                disabled
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group controlId="email">
                            <Form.Label>Supplier Email :</Form.Label>
                            <Form.Control
                                type="text"
                                value={supplierDetails.email}
                                disabled
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group controlId="address">
                            <Form.Label>Supplier Address:</Form.Label>
                            <Select
                                options={supplierAddresses}
                                placeholder="Select Address"
                                onChange={handleSupplierAddressesChange}
                                value={supplierMultipleAddress} // This will show the selected address
                                isClearable
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group >
                            <Form.Label >Status</Form.Label>
                            <Form.Control
                                type="text"
                                value={status}
                                onChange={(e) => setstatus(e.target.value)}
                                disabled
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <hr />
                <br />
                <div>
                    <Row>
                        <Col md='12'>
                            <label htmlFor="products">Select a Product:</label>
                            <Select
                                value={selectedProduct}
                                onChange={handleProductChange}
                                options={productOptions}
                                placeholder="Select Product"
                            />
                        </Col>
                    </Row>
                    <br />
                    <div className="table-responsive">
                        <Table>
                            <thead>
                                <tr>
                                    <th>Product Description</th>
                                    <th>MTR No</th>
                                    <th>Detail Material Description</th>
                                    <th>Visual Inspection</th>
                                    <th>Dimensional Inspection</th>
                                    <th>Marking on Material</th>
                                    <th>Verification of MTR</th>
                                    <th>Remark if any</th>
                                    <th>Measuring Instruments</th>
                                    <th>Inspection Mark</th>
                                    <th>Quantity Received (Specify Unit)</th>
                                    <th>Quantity Accepted (Specify Unit)</th>
                                    <th>Calibration Valid up to</th>
                                    <th>Make</th>
                                    <th>Heat No / Batch No</th>
                                    <th>Plate No./ Sr. No</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row, index) => (
                                    <tr key={index}>
                                        <td>
                                            <div>
                                                <div>
                                                    {row.product.name}
                                                    <hr />
                                                </div>
                                                <div>
                                                    <div>
                                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                            {[
                                                                { label: 'MOC', value: row.moc },
                                                                { label: 'Type', value: row.type },
                                                                { label: 'Size', value: row.size },
                                                                { label: 'Rating', value: row.rating },
                                                                { label: 'Class', value: row.classes },
                                                                { label: 'Schedule', value: row.schedule },
                                                                { label: 'Certification', value: row.certification },
                                                            ].map((item, index) => (
                                                                <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '0px' }}>
                                                                    <label style={{ minWidth: '100px', marginRight: '0px' }}>{item.label}:</label>
                                                                    <span>{item.value}</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>

                                        </td>
                                        <td>
                                            <div>
                                                <Form.Control
                                                    className="remark"
                                                    type="text"
                                                    value={row.mtrno}
                                                    onChange={(e) => handleRowChange(index, 'mtrno', e.target.value)}
                                                    placeholder="Enter item mtrno"
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <Form.Control
                                                    className="remark"
                                                    type="text"
                                                    value={row.detailmaterialdescription}
                                                    onChange={(e) => handleRowChange(index, 'detailmaterialdescription', e.target.value)}
                                                    placeholder="Enter item detailmaterialdescription"
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <Form.Select
                                                    className="quantity"
                                                    value={row.visualinspection}
                                                    onChange={(e) => handleRowChange(index, 'visualinspection', e.target.value)}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="Yes">Yes</option>
                                                    <option value="No">No</option>
                                                </Form.Select>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <Form.Select
                                                    className="quantity"
                                                    value={row.dimensionalinspection}
                                                    onChange={(e) => handleRowChange(index, 'dimensionalinspection', e.target.value)}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="Yes">Yes</option>
                                                    <option value="No">No</option>
                                                </Form.Select>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <Form.Select
                                                    className="quantity"
                                                    value={row.markingonmaterial}
                                                    onChange={(e) => handleRowChange(index, 'markingonmaterial', e.target.value)}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="Yes">Yes</option>
                                                    <option value="No">No</option>
                                                    <option value="NA">N/A</option>
                                                </Form.Select>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <Form.Select
                                                    className="quantity"
                                                    value={row.verificationofmtr}
                                                    onChange={(e) => handleRowChange(index, 'verificationofmtr', e.target.value)}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="Yes">Yes</option>
                                                    <option value="No">No</option>
                                                    <option value="NA">N/A</option>
                                                </Form.Select>
                                            </div>
                                        </td>

                                        <td>
                                            <div>
                                                <Form.Control
                                                    className="remark"
                                                    type="text"
                                                    value={row.remarksifany}
                                                    onChange={(e) => handleRowChange(index, 'remarksifany', e.target.value)}
                                                    placeholder="Enter item remarksifany"
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <Form.Control
                                                    className="remark"
                                                    type="text"
                                                    value={row.measuringinstruments}
                                                    onChange={(e) => handleRowChange(index, 'measuringinstruments', e.target.value)}
                                                    placeholder="Enter item measuringinstruments"
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <Form.Control
                                                    className="remark"
                                                    type="text"
                                                    value={row.inspectionmark}
                                                    onChange={(e) => handleRowChange(index, 'inspectionmark', e.target.value)}
                                                    placeholder="Enter item inspectionmark"
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <Form.Control
                                                    className="quantity"
                                                    type="number"
                                                    value={row.quantityreceived}
                                                    onChange={(e) => handleRowChange(index, 'quantityreceived', e.target.value)}
                                                    placeholder="Enter item quantityreceived"
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <Form.Control
                                                    className="quantity"
                                                    type="number"
                                                    value={row.quantityaccepted}
                                                    onChange={(e) => handleRowChange(index, 'quantityaccepted', e.target.value)}
                                                    placeholder="Enter item quantityaccepted"
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <Form.Control
                                                    className="remark"
                                                    type="text"
                                                    value={row.calibrationvalidupto}
                                                    onChange={(e) => handleRowChange(index, 'calibrationvalidupto', e.target.value)}
                                                    placeholder="Enter item calibrationvalidupto"
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <Form.Control
                                                    className="remark"
                                                    type="text"
                                                    value={row.make}
                                                    onChange={(e) => handleRowChange(index, 'make', e.target.value)}
                                                    placeholder="Enter item make"
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <Form.Control
                                                    className="remark"
                                                    type="text"
                                                    value={row.heatnobatchno}
                                                    onChange={(e) => handleRowChange(index, 'heatnobatchno', e.target.value)}
                                                    placeholder="Enter item heatnobatchno"
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <Form.Control
                                                    className="remark"
                                                    type="text"
                                                    value={row.platenosrno}
                                                    onChange={(e) => handleRowChange(index, 'platenosrno', e.target.value)}
                                                    placeholder="Enter item platenosrno"
                                                />
                                            </div>
                                        </td>

                                        <td>
                                            <IoMdClose className="close-icon" onClick={() => removeRow(index)} />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>

                        </Table>
                    </div>
                </div>
                <br />
                <button className="button-70" type="button" onClick={handleSubmit}>
                    SUBMIT
                </button>
            </Form>
        </div>
    );
};
export default IRMDCreate;